module.exports = __webpack_public_path__ + "static/media/CRboxKlearviewIcon.524f57de.svg";